import React from "react";
import { type UsersTableProps } from "utils/types/usersManagement.type";
import UserTableRow from "./UserTableRow";

export default function UsersTable({ users, isLoading }: UsersTableProps) {
  return (
    <div className="table-wrapper max-h-[48rem] overflow-auto">
      <table className="w-full">
        <thead>
          <tr>
            <th className="rounded-l-lg border border-black-800/30 border-r-0 py-5 px-5 text-left">
              Date
            </th>
            <th className="py-5 px-5 border-y border-black-800/30 text-left">
              Name
            </th>
            <th className="py-5 px-5 border-y border-black-800/30 text-left">
              Email
            </th>
            <th className="py-5 px-5 border-y border-black-800/30 text-left">
              Verified
            </th>
            <th className="py-5 px-5 border-y border-black-800/30 text-left">
              2FA
            </th>
            <th className="rounded-r-lg border border-black-800/30 border-l-0 py-5 px-16 text-left">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && (
            <tr>
              <td colSpan={6} className="text-center py-5">
                Loading...
              </td>
            </tr>
          )}
          {!isLoading && users && users.map((item) => (
            <UserTableRow key={item?.id} user={item} />
          ))}
          {!isLoading && users && users.length === 0 && (
            <tr>
              <td colSpan={6} className="text-center py-5">
                No Results Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

